const Backbone = require("backbone");
var ApiConfig = require("_lib/data/ApiConfig.js");

var Feedback = Backbone.Model.extend({
  urlRoot: ApiConfig.getPrefix() + "/user/feedback",
});

module.exports = Feedback;
